module.exports = __webpack_public_path__ + "img/logo-plus.43bf3b4c.png";